import { LiveChoiceButtons } from './LiveChoiceButtons';

const URGENCY_OPTS = [
  { id: 'low', label: 'Low', hint: 'Can wait' },
  { id: 'medium', label: 'Medium', hint: 'Some time pressure' },
  { id: 'high', label: 'High', hint: 'Needs speed' },
];

const CORRECTNESS_OPTS = [
  { id: 'low', label: 'Low', hint: 'Directional is fine' },
  { id: 'medium', label: 'Medium', hint: 'Should be sound' },
  { id: 'high', label: 'High', hint: 'Must be right' },
];

interface FastVsRightLiveProps {
  decisionName: string;
  context?: string;
  urgencyLevel: 'low' | 'medium' | 'high' | null;
  correctnessLevel: 'low' | 'medium' | 'high' | null;
  onUrgencySelect: (level: 'low' | 'medium' | 'high') => void;
  onCorrectnessSelect: (level: 'low' | 'medium' | 'high') => void;
}

export function FastVsRightLive({
  decisionName,
  context,
  urgencyLevel,
  correctnessLevel,
  onUrgencySelect,
  onCorrectnessSelect,
}: FastVsRightLiveProps) {
  const step = urgencyLevel == null ? 'urgency' : correctnessLevel == null ? 'correctness' : 'done';

  return (
    <div className="max-w-xl mx-auto">
      <div className="border border-[var(--rule)] bg-[var(--surface)] p-4 mb-6">
        <div className="font-body text-[0.85rem] font-medium text-[var(--text-pri)]">{decisionName}</div>
        {context && (
          <div className="font-body text-[0.75rem] text-[var(--text-ter)] mt-2 leading-relaxed">{context}</div>
        )}
      </div>

      {step === 'urgency' && (
        <>
          <div className="font-heading text-[0.52rem] tracking-[0.14em] uppercase text-electric-mustard-600 mb-3 text-center">
            Step 1 — How urgent is this decision?
          </div>
          <LiveChoiceButtons
            prompt="How much time pressure do you face?"
            options={URGENCY_OPTS}
            selectedId={urgencyLevel}
            onSelect={id => onUrgencySelect(id as 'low' | 'medium' | 'high')}
          />
        </>
      )}

      {step === 'correctness' && (
        <>
          <div className="font-heading text-[0.52rem] tracking-[0.14em] uppercase text-electric-mustard-600 mb-3 text-center">
            Step 2 — How much does being right matter?
          </div>
          <LiveChoiceButtons
            prompt="How costly would a wrong call be?"
            options={CORRECTNESS_OPTS}
            selectedId={correctnessLevel}
            onSelect={id => onCorrectnessSelect(id as 'low' | 'medium' | 'high')}
          />
        </>
      )}

      {step === 'done' && (
        <p className="font-body text-[0.82rem] text-center text-alpine-green-400">
          Assessment complete — submit your response when ready.
        </p>
      )}
    </div>
  );
}
